import axios from 'axios'

export default axios.create({
  baseURL: process.env.ROOT_API_CALENDARS,
  timeout: 18000,
  crossDomain: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
})



// WEBPACK FOOTER //
// ./src/services/axios-mongo-calendars.js